<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="topic"
        :value="$t('components.drawer.plan_files')"
        v-if="
          planIdentity.HasDrupalPortal &&
          planIdentity.MembersPortal &&
            planIdentity.MembersPortal.IsActive &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Documents Management Admin') > -1 ||
              role.indexOf('Employer Members Viewer') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'adminFiles',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.reports.view_&_download") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="topic"
        :value="$t('components.drawer.plan_files')"
        v-if="
          (!planIdentity.MembersPortal || planIdentity.PlanType === 'NoManaged') &&
            (role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Plan Admin') > -1 ||
              role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Documents Management Admin') > -1 ||
              role.indexOf('Employer Members Viewer') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'planFiles',
                  params: { planId: selectedPlan.Id, mode: 'plan' },
                })
              "
            >
              {{ $t("components.vuematerialdashboard.core.drawer.view_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="contact_page"
        :value="$t('views.members.members_files')"
        v-if="
        useDocumentsManagement &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            role.indexOf('Broker Plan Admin') > -1 ||
            role.indexOf('Employer Plan Admin') > -1 ||
            role.indexOf('Documents Management Admin') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'membersFiles',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.manage") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="work"
        :value="$t('components.employers.employer_details.employers_files')"
        v-if="
        useDocumentsManagement &&
        (planIdentity.PlanType === 'HW' || planIdentity.PlanType === 'Pension') &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            role.indexOf('Broker Plan Admin') > -1 ||
            role.indexOf('Employer Plan Admin') > -1 ||
            role.indexOf('Documents Management Admin') > -1 )
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'employersFiles',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.manage") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="work"
        :value="$t('components.employers.employer_details.employers_uploads')"
        v-if="
        useDocumentsManagement &&
        planIdentity.PlanType === 'NoManaged' &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            role.indexOf('Broker Plan Admin') > -1 )
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center  flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'planFiles',
                  params: { planId: selectedPlan.Id, mode: 'employer' },
                })
              "
            >
              {{ $t("views.members.manage") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import SettingsService from "@/services/settings.service.js";
export default {
  data() {
    return {
      commissionsCount: 3,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
  },
  mixins: [planSetter],
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
  },
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
